"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RightType;
(function (RightType) {
    RightType["TEMPLATE"] = "rightTemplate";
    RightType["REPORT"] = "rightReport";
    RightType["SCHEDULE"] = "rightSchedule";
    RightType["USER"] = "rightUser";
    RightType["CARTO"] = "rightCarto";
    RightType["EVENT"] = "rightEvent";
    RightType["PAD"] = "rightPad";
    RightType["LINK"] = "rightLink";
    RightType["INTERFACE"] = "rightInterface";
    RightType["ALERT"] = "rightAlert";
    RightType["PLANNING"] = "rightPlanning";
    RightType["STOPNGO"] = "rightStopNGo";
    RightType["ATMOSPHERE"] = "rightAtmosphere";
})(RightType = exports.RightType || (exports.RightType = {}));
